import React from 'react';
import { Helmet } from 'react-helmet-async';
import { Link } from 'react-router-dom';
import Header from '../components/Header';
import Footer from '../components/Footer';

const Contact: React.FC = () => {
  return (
    <div className="min-h-screen bg-[#000000] text-white flex flex-col">
      <Helmet>
        <title>Contact | AmmoPantryAI</title>
        <meta name="robots" content="index, follow" />
      </Helmet>
      <Header />
      <div className="flex-1 flex items-center justify-center px-4 py-20">
        <div className="max-w-md w-full text-center">
          <div className="mb-8">
            <h1 className="text-4xl font-extrabold text-white mb-4">Contact Us</h1>
            <p className="text-lg text-[#a3a3a3] mb-8">
              Have questions about AmmoPantryAI? We'd love to hear from you.
            </p>
          </div>

          <div className="bg-[#1a1a1a] border border-white/10 rounded-2xl p-8">
            <div className="mb-6">
              <h2 className="text-xl font-semibold text-white mb-2">Get in Touch</h2>
              <p className="text-[#a3a3a3] mb-6">
                Send us an email and we'll get back to you as soon as possible.
              </p>
            </div>

            <a
              href="mailto:ammopantry@gmail.com"
              className="inline-flex items-center justify-center w-full bg-[#3b82f6] hover:bg-[#2563eb] text-white font-semibold py-4 px-8 rounded-xl transition-colors duration-200 text-lg"
            >
              <svg className="w-5 h-5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2}
                  d="M3 8l7.89 4.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
              </svg>
              Email Support
            </a>

            <p className="text-sm text-[#a3a3a3] mt-4">ammopantry@gmail.com</p>
          </div>

          <div className="mt-8">
            <Link to="/" className="text-[#3b82f6] hover:text-white transition font-medium">
              ← Back to Home
            </Link>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default Contact;
